import {
  API_HEADER,
  API_URL,
  USER_URL,
} from "@modules/shared/enums/common-enum";
import { PaginationEntity } from "@modules/shared/entities/paginations/pagination.entity";
import { TrainersEntity } from "../entities/trainers.entity";
import { AuthenticationEntity } from "@modules/auth/entities/auth.entity";
import { fetchWithAuth } from "@modules/shared/helpers/fetch-with-auth.helper";

export class TrainersService {
  /** Read a value trying snake_case first, then camelCase (and any extra aliases). */
  private pick<T = any>(source: any, ...keys: string[]): T | undefined {
    if (!source || typeof source !== "object") return undefined;
    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null) {
        return value as T;
      }
    }
    return undefined;
  }

  private getTrainerSubscription(trainer: any): string | null {
    const direct = this.pick<string>(
      trainer,
      "subscription",
      "trainer_subscription",
      "trainerSubscription",
    );

    return typeof direct === "string" ? direct : null;
  }

  private getHeaders(): HeadersInit {
    return {
      ...API_HEADER,
      "Content-Type": "application/json",
    };
  }

  /** Lấy danh sách trainers */
  async getTrainers(
    auth: AuthenticationEntity | null,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    page: number,
    verified?: boolean,
    sort?: 1 | -1,
  ) {
    const query = new URLSearchParams({
      page: String(page),
      limit: "12",
    });
    if (typeof verified === "boolean") {
      query.set("verified", String(verified));
    }
    if (typeof sort === "number") {
      query.set("sort", String(sort));
    }

    const res = await fetchWithAuth(
      `${API_URL.TRAINERS}?${query.toString()}`,
      {
        method: "GET",
        headers: this.getHeaders(),
      },
      auth,
      setAuth,
      logout,
    );

    // res.data chứa { data, pagination, status_code }
    if (res.status_code !== 200) {
      throw new Error(res.message || "Failed to fetch trainers");
    }

    const trainerList: TrainersEntity[] = res.data.map((trainer: any) => ({
      id: this.pick(trainer, "id", "_id"),
      name: this.pick(trainer, "name"),
      role: this.pick(trainer, "role"),
      subscription: this.getTrainerSubscription(trainer),
      expertise: this.pick(trainer, "expertise"),
      address: this.pick(trainer, "address") ?? null,
      avatars: this.pick(trainer, "avatars") ?? null,
      bio: this.pick(trainer, "bio"),
      certifications: this.pick(trainer, "certifications"),
      dateOfBirth: this.pick(trainer, "date_of_birth", "dateOfBirth"),
      email: this.pick(trainer, "email"),
      fitCoins: this.pick(trainer, "fit_coins", "fitCoins"),
      fitnessGoal: this.pick(trainer, "fitness_goal", "fitnessGoal"),
      gender: this.pick(trainer, "gender"),
      height: this.pick(trainer, "height"),
      phoneNumber: this.pick(trainer, "phone_number", "phoneNumber"),
      skill: this.pick(trainer, "skill"),
      status: this.pick(trainer, "status"),
      username: this.pick(trainer, "username"),
      weight: this.pick(trainer, "weight"),
      createdAt: this.pick(trainer, "created_at", "createdAt"),
      verified: this.pick(trainer, "verified"),
    }));

    const paginationEntity: PaginationEntity = new PaginationEntity(
      res.pagination.page,
      res.pagination.total,
      res.pagination.limit,
    );

    console.log(res);

    return { TrainersList: trainerList, Pagination: paginationEntity };
  }

  /** Xóa trainer */
  async deleteTrainer(
    auth: AuthenticationEntity | null,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    trainerId: string,
  ): Promise<boolean> {
    const res = await fetchWithAuth(
      `${USER_URL}/${trainerId}`,
      {
        method: "DELETE",
        headers: this.getHeaders(),
      },
      auth,
      setAuth,
      logout,
    );

    return res.status_code === 200;
  }
}
